import { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { createUseStyles } from 'react-jss'
import ImageZoom from '@/components/ImageZoom'
import MagneticWrapper from '@/components/MagneticWrapper'
import style from './style'

const useStyles = createUseStyles(style)

const DiagonalGallery = ({
  items,
}) => {
  const classes = useStyles()
  const [hover, setHover] = useState(null)

  const handleMouseEnter = (index) => setHover(index)
  const handleMouseLeave = () => setHover(null)

  return items.length > 0 && (
    <div className={classes.root}>
      {items.map((item, i) => (
        <MagneticWrapper
          key={i.toString()}
          className={classNames({
            [classes.imgWrapper]: true,
            [`imgWrapper_${i}`]: true,
            [classes.imgHover]: hover === i,
          })}
          onMouseEnter={() => handleMouseEnter(i)}
          onMouseLeave={handleMouseLeave}
        >
          <ImageZoom
            img={item.src}
            alt={item.caption}
            width={510}
            height={400}
            scaleImgOnScroll
          />
        </MagneticWrapper>
      ))}
    </div>
  )
}

DiagonalGallery.propTypes = {
  items: PropTypes.array.isRequired,
}

export default DiagonalGallery
